import { render } from "./NewCourseModal.vue?vue&type=template&id=4648fd0e"
import script from "./NewCourseModal.vue?vue&type=script&lang=js"
export * from "./NewCourseModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__